<template>
  <div>
    <div id="bottombar-spacer"></div>
    <div id="bottombar">
      <textarea
        class="materialize-textarea"
        v-model="message_text"
        :placeholder="placeholder_text"
        maxlength="120"
        required
      ></textarea>
      <a @click="postMessage">投稿</a>
    </div>
  </div>
</template>

<script>
import * as firebase from "firebase/app";
import "firebase/database";
import materialize from "materialize-css";

import { db } from "./../../App.vue";

export default {
  name: "Bottombar",
  props: {
    is_login: Boolean,
    current_user_id: String,
    current_user_nickname: String
  },
  data: function() {
    return {
      message_text: ""
    };
  },
  computed: {
    roomId: function() {
      return this.$route.params.room_id;
    },
    placeholder_text: function() {
      return this.is_login
        ? "商品の感想を投稿しよう"
        : "ログインして感想を投稿しよう";
    }
  },
  methods: {
    postMessage: function() {
      if (
        !this.is_login ||
        this.current_user_id === null ||
        this.current_user_nickname === null
      ) {
        materialize.toast({
          html: "ログインが必要です",
          displayLength: 1000
        });
        return;
      }
      if (this.message_text.length === 0) {
        materialize.toast({
          html: "空欄では投稿できません",
          displayLength: 1000
        });
        return;
      }
      if (this.message_text.length > 120) {
        materialize.toast({
          html: "120文字以内にしてください",
          displayLength: 1000
        });
        return;
      }
      let new_message = {
        text: this.message_text,
        nickname: this.current_user_nickname,
        user_id: this.current_user_id,
        timestamp: firebase.database.ServerValue.TIMESTAMP
      };
      db.ref(`messages/${this.roomId}`).push(new_message);
      this.message_text = "";
      this.$nextTick(function() {
        materialize.textareaAutoResize(document.querySelector("textarea"));
        this.scrollToTop();
      });
    },
    scrollToTop: function() {
      window.scroll({
        top: 0,
        left: 0,
        behavior: "smooth"
      });
    }
  }
};
</script>

<style lang="scss" scoped>
#bottombar-spacer {
  height: env(safe-area-inset-bottom); // Safari safe area
  height: constant(safe-area-inset-bottom); // Safari safe area
}
#bottombar {
  position: fixed;
  bottom: 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding-bottom: env(safe-area-inset-bottom); // Safari safe area
  padding-bottom: constant(safe-area-inset-bottom); // Safari safe area

  border-top: 2px solid #f93099;
  box-shadow: 0px -2px 2.35px 0.15px rgba(0, 0, 0, 0.15);
  background-color: #fee6f3;

  ::placeholder {
    color: #fb9fca;
    font-size: 14px;
    font-family: HiraKakuPro-W3;
    line-height: 0.68;
    padding-top: 6px;
  }
  .materialize-textarea {
    border-bottom: none;
    line-height: 1.57;
    padding: 0px;
    font-size: 14px;
    padding-top: 16.5px;
    margin-left: 17px;
    margin-right: 88px;
  }
  a {
    cursor: pointer;
    user-select: none;
    position: fixed;
    right: 15px;
    bottom: 10.5px;
    width: 50px;
    height: 30px;
    border-radius: 15px;
    margin-bottom: env(safe-area-inset-bottom);
    margin-bottom: constant(safe-area-inset-bottom);
    background-color: #f93099;
    color: #ffffff;
    font-size: 14px;
    line-height: 0.68;
    font-family: HiraKakuPro-W6;
    padding: 11px 11px;
  }
}
</style>
